export default __webpack_public_path__ + "static/media/glare_look_colour.f90767d8.jpg";